import { Reveal, SectionHead } from "@/components/Reveal";

const PRIMARY = ["Aluminum", "Titanium", "Stainless & nickel alloys", "Carbon & alloy steels", "Copper & brass", "Plastics"];
const SPECIALTY = ["Kovar", "Molybdenum", "Tantalum"];

// G — Materials, as a technical grid panel.
export const Materials = () => (
  <section data-testid="materials-section" className="on-light bg-[var(--cream-2)] py-24 sm:py-32">
    <div className="wrap">
      <SectionHead
        no="04"
        eyebrow="MATERIAL EXPERIENCE"
        title={<>Start with the material <span className="font-serif-i">your application demands.</span></>}
        intro="Aluminum. Titanium. Stainless and nickel alloys. Carbon and alloy steels. Copper and brass. Plastics."
      />
      <Reveal delay={0.14}>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-[var(--grey)] sm:text-lg [text-wrap:pretty]">
          PMP also lists experience with specialty materials including Kovar, molybdenum, and tantalum.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {PRIMARY.map((m, i) => (
          <Reveal key={m} delay={i * 0.05}>
            <div data-testid={`material-${m.split(" ")[0].toLowerCase()}`} className="card flex items-center justify-between px-6 py-5">
              <span className="text-[1.05rem] font-medium tracking-[-0.01em] text-[var(--ink)]">{m}</span>
              <span className="font-mono text-[10px] tracking-[0.2em] text-[var(--blue)]">{String(i + 1).padStart(2, "0")}</span>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.3} className="sm:col-span-2 lg:col-span-3">
          <div className="flex flex-col gap-4 rounded-[0.75rem] border border-[var(--blue)]/30 bg-[#eef1ff] px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-mono text-[11px] tracking-[0.2em] text-[var(--ink-soft)]">
              SPECIALTY EXPERIENCE — {SPECIALTY.join(" · ").toUpperCase()}
            </p>
            <button
              type="button"
              data-testid="materials-share-button"
              className="btn btn-dark shrink-0"
              onClick={() => { const el = document.getElementById("contact"); if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 }); else el?.scrollIntoView({ behavior: "smooth" }); }}
            >
              Share Your Material Requirements
            </button>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.34}>
        <p className="mt-8 max-w-2xl text-[15px] leading-relaxed text-[var(--grey)] [text-wrap:pretty]">
          Share the grade, geometry, and requirements so we can discuss suitability for your project.
        </p>
      </Reveal>
    </div>
  </section>
);
